import React, { useState, useEffect, useRef } from "react";
import { debounce } from 'throttle-debounce';
import { compose } from "redux";
import utils from "fantastic/lib/utils";
import connectActions from "fantastic/lib/connectActions";
import actions from "fantastic/actions";

import styles from "fantastic/components/hoc/styles";

const DEFAULT_TD_PADDING_BOTTOM = 20;
const NONE = "none";

const { px, url } = utils;

const aStyles = (style, { height }) => {
  const styles = {
    padding: `${px(height)} ${px(DEFAULT_TD_PADDING_BOTTOM)}`
  };

  return { ...style, ...styles };
};

const tdStyles = ({
  css_padding_top,
  css_padding_right,
  css_padding_left,
  css_padding_bottom
}) => {
  const styles = {
    paddingBottom: px(css_padding_bottom),
    paddingLeft: px(css_padding_left),
    paddingRight: px(css_padding_right),
    paddingTop: px(css_padding_top)
  };
  return styles;
};

const Button = props => {
  const {
    id,
    href,
    label,
    style,
    dimension,
    update,
    width,
    height,
    preview,
    css_padding_left,
    css_padding_right,
    css_padding_top,
    css_padding_bottom,
    text_align = 'justify'
  } = props;
  const btn = useRef({});

  const setButtonDimension = (btn, dimension) => {
    if (preview) return;
    const width = Math.floor(btn.offsetWidth);
    const height = Math.floor(btn.offsetHeight)

    const attrs = {
      width: width,
      dimension: [width, height]
    };
    if (dimension &&
      dimension[0] === width &&
      dimension[1] === height
    ) return;
    if (isNaN(width) || isNaN(height)) return;

    update(id, attrs);
  };

  const debouncedSetButtonDimension = useRef(debounce(500, setButtonDimension)).current;

  useEffect(() => {
    debouncedSetButtonDimension(btn.current, dimension);
  }, [width,
    css_padding_left,
    css_padding_right,
    css_padding_top,
    css_padding_bottom,
    text_align,
    height,
    label]);

  const handleClick = event => {
    event.preventDefault();
  };

  const tableClasses = [
    "button",
    text_align
  ];

  return (
    <table className={tableClasses.join(' ')}>
      <tbody>
        <tr>
          <td style={tdStyles(props)}>
            <a style={aStyles(style, props)} href={href} ref={btn} onClick={handleClick}>
              {label}
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default compose(
  connectActions({update: actions.updateNode}),
  styles("background", "font", "color", "border")
)(Button);
